import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import FontAwesome from 'react-fontawesome'
import { Button, Modal } from 'react-bootstrap'
import '../Tyre.css';
import TyreStore from 'stores/TyreStore'
import AssetVehicleDoc from './AssetVehicleDoc'
import {connect} from 'react-redux'
// import AssetVehicleServiceDoc from './AssetVehicleServiceDoc'
// import AssetVehicleGenForm from './AssetVehicleGenForm'
class ReportAssetVehiclePage extends Component {
  constructor(props) {
    super(props)

    this.state = {	 	
      loading:false,
      showTb:true,
      data:[],
      showAdd:false,
      action:'',
      vehicle_id:''
    }
  }

  componentDidMount() {
    this.loadData()
  }

  componentWillReceiveProps(newProps) {
    if (newProps.showTbReportAssetVehiclePage) {
        this.setState({showTb:newProps.showTbReportAssetVehiclePage})
        this.loadData()
    }
  }

  loadData() {
      this.setState({loading:true})
      TyreStore.loadReportAssetVehicle((result)=>{
        this.setState({loading:false,data:result.data})
      })
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  onNewClick() {
    this.setState({showTb:false,action:'add',vehicle_id:''})
    if (this.props.onShowTabs!==undefined)
        this.props.onShowTabs(false)
  }

  onRowSelect(item) {
      let {mode} = this.props
      if (mode!=='tyre-repair-inside-doc') {
        this.setState({showTb:false,action:'',vehicle_id:item.vehicle_id})
        if (this.props.onShowTabs!==undefined)    
            this.props.onShowTabs(false)
      }
      if (this.props.onRowSelect!==undefined)
        this.props.onRowSelect(item)
  }

  onDocClose() {
    this.loadData() 
    this.setState({showTb:true,action:'',vehicle_id:''})
    if (this.props.onShowTabs!==undefined)
        this.props.onShowTabs(true)
  }

  onAfterSave(item) {
    this.onRowSelect(item)
    this.setState({showAdd:false})
  }

  renderRowData() {
      let {data} = this.state
      if (data.length===0) {
          return(<tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
      } else {
          return(
            data.map((item,index)=>
                <tr onClick={this.onRowSelect.bind(this,item)} key={index}>
                    <td className='text-center'>{index+1}</td>
                    <td className='text-center'>{item.brand}</td>
                    <td className='text-center'>{item.model}</td>
                    <td className='text-center'>{item.vehicle_registration_no}</td>
                    <td className='text-center'>{item.vehicle_no}</td>
                    <td className='text-center'>{item.chassis_no}</td>
                    <td className='text-center'>{item.vehicle_type}</td>
                    
                </tr>
            )
          )
      }
  }

  renderTable() {
      return(
          <div className='table-responsive'>
            <table className='table table-bordered-solid table-hover'>
                <thead>
                    <tr>
                        <th className='text-center' style={{minWidth:'50px',width:'50px'}}>ลำดับ</th>
                        <th className='text-center' style={{minWidth:'120px',width:'120px'}}>ยี่ห้อ</th>
                        <th className='text-center' style={{minWidth:'120px',width:'120px'}}>รุ่น</th>
                        <th className='text-center' style={{minWidth:'110px',width:'110px'}}>เลขทะเบียน</th>
                        <th className='text-center' style={{minWidth:'110px',width:'110px'}}>เบอร์รถ</th>
                        <th className='text-center' style={{minWidth:'110px',width:'110px'}}>หมายเลขตัวถัง</th>
                        <th className='text-center' style={{minWidth:'110px',width:'100px'}}>ประเภท</th>                        
                    </tr>    
                </thead>
                <tbody>
                    {this.renderRowData()}
                </tbody>        
            </table>
          </div>
      )
  }

  renderFormModal() {
    let {showAdd} = this.state
    return(
        <Modal
            show={showAdd}
            onHide={()=>{this.setState({showAdd:false})}}
            dialogClassName="midwidth-dialog"
        >
            <Modal.Header closeButton>
                <Modal.Title>เพิ่มรถ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* <AssetVehicleGenForm
                    vehicleId=''
                    onClose={()=>{this.setState({showAdd:false})}}
                    onAfterSave={this.onAfterSave.bind(this)}
                /> */}
            </Modal.Body>
        </Modal>
    )
  }

  render() {
    let {loading,showTb,action} = this.state
    let {mode} = this.props
    return(
    	<div>
            <div style={{display:(showTb?'':'none')}}>
                <Box loading={loading}>
                    <Box.Header border={true}>
                        <Box.Title>ตารางรายงานยานพาหนะ</Box.Title>
                        {mode==='tyre-repair-inside-doc'?''
                        :
                        <Box.Tools>
                            <Button 
                                onClick={this.onNewClick.bind(this)}
                                bsStyle={'link'}
                                className='text-large'
                            >
                                <FontAwesome name='plus' />&nbsp;เพิ่มสินทรัพย์/เครื่องจักร
                            </Button>
                        </Box.Tools>}
                    </Box.Header>
                    <Box.Body>
                        {this.renderTable()}
                    </Box.Body>                
                </Box>
            </div>  
            {this.renderFormModal()}
	      	<div style={{display:(showTb?'none':'')}}>
                <AssetVehicleDoc
                    // ref='assetVehicleDoc'
                    workNo={''}
                    action={action}
                    onClose={this.onDocClose.bind(this)}
                    showTb={showTb}
                    editMode={this.props.editMode}
                    vehicleId={this.state.vehicle_id}
                />
            </div>			      
	    </div>  
    )
  }
}

ReportAssetVehiclePage.defaultProps = {
  editMode:false,
  mode:''
}

export default ReportAssetVehiclePage = connect(
    (state) => ({messages: state.message.view.tyre.ReportAssetVehiclePage}),null,null,{withRef:true}
)(ReportAssetVehiclePage);


// WEBPACK FOOTER //
// ./src/view/tyre/report-asset-vehicle-page/ReportAssetVehiclePage.js